import React from 'react';
import StatTile from '../common/StatTile';
import { formatUSDT } from '../../utils/format';
import { useContractState } from '../../context/ContractContext';

export default function TeamStats() {
  const { extended, levelCounts } = useContractState();
  const totalTeam = (levelCounts || []).reduce((a, b) => a + b, 0);
  return (
    <div className="team-hero">
      <StatTile label="Direct Referrals" value={extended ? extended.directReferrals : 0} />
      <StatTile label="Total Team" value={totalTeam} />
      <StatTile label="Team Volume" value={extended ? formatUSDT(extended.teamVolume) : '$0.00'} />
      <StatTile label="Upline ID" value={extended ? '#' + extended.referrerId : '—'} />
    </div>
  );
}
